SupportBasePresentation = require('./base')
SupportLocalStatusAndNotesPresentation = require('./local_messages')

class SupportLocalPresenterPresentation extends SupportBasePresentation
	getLookupObject: () ->
		SupportLocalStatusAndNotesPresentation

module.exports = SupportLocalPresenterPresentation
